import { Component, Provider }       from '@angular/core';
import { ActivatedRoute, Params }  from '@angular/router';
import { Location }        from '@angular/common';
import * as _ from 'lodash';


import { SellerService } from '../../services/sellers/seller.service';

import { UserDetailComponent } from '../../users/detail/user-detail.component';
import { ProviderService } from '../../services/providers/provider.service';
import { Auth } from '../../services/auth.service';
@Component({
  selector: 'seller-detail',
  templateUrl: './seller-detail.component.html',
  styleUrls: [ '../../users/detail/user-detail.component.css' ]
})
export class SellerDetailComponent extends UserDetailComponent {

  providers: any[]
  selectedProviderIndex:any
  hasBOUsersPermission:Boolean = false;

  constructor(
    protected sellerService: SellerService,
    protected route: ActivatedRoute,
    protected location: Location,
    protected providerService: ProviderService,
    protected auth: Auth
  ) { super(sellerService, route, location); }

  protected getDefaultUserImageUrl(): string {

    return 'http://www.arcadegrab.com/uploads/avatars/user-1.png';
  };

  fillObject(): void {
    this.hasBOUsersPermission = this.auth.hasBOUsersPermission();
    if(!this.hasBOUsersPermission){
      $(document).ready (() => {
        var inputs = document.getElementsByTagName('input');
        var selects = document.getElementsByTagName('select');
        Array.from(inputs).forEach((input) => input.setAttribute("disabled",""));
        Array.from(selects).forEach((select) => select.setAttribute("disabled",""));
      })
    }
  }

  getProviders(){
    this.providerService.get().then((response)=>{
      for (var i = 0 ; i<response.length;i++){
        if (response[i].id==this.user.provider.id) this.selectedProviderIndex = i
      }
      this.providers = response
      console.log(this.selectedProviderIndex)

    })
  }

  protected getUpdatedFields(): any {

    let updatedFields = {};
    let self = this;
    _.each(self.updatedUser, function (value: any, key: string) {

      if (key=='provider'){
        if (self.user[key].id!=self.providers[self.selectedProviderIndex].id)
        updatedFields[key] = self.providers[self.selectedProviderIndex].id;
      }
      if (self.user[key] !== value) {
        updatedFields[key] = value;
        console.log("adentro save")
      }


    });
    console.log(updatedFields)
    return updatedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/seller/seller-detail/seller-detail.component.ts